import React from 'react';
import styled from 'styled-components';
import { SelectPicker } from 'rsuite';
import { ControlLabel, FormGroup } from '../../../widgets/FormElements';

export const StyledFormGroup = styled(FormGroup)`
  margin-bottom: 10px;
`;

export const ItemsControlLabel = styled(ControlLabel)`
  margin-left: 12px;
  width: 100% !important;
  text-align: left !important;
`;

export const CustomFormControl = styled(({ className, ...props }) => (
  <div {...props} className={`${className} rs-form-control-wrapper`} />
))`
  display: inline-block;
`;

export const LimitRulesSelectPicker = styled(SelectPicker)`
  &.rs-picker-has-value {
    .rs-btn.rs-btn-default {
      padding-left: 4px;
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }
`;
